import React from 'react';
import { Col } from 'react-bootstrap';
import { faQuoteRight } from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faInstagram, faLinkedin, faYoutube } from '@fortawesome/free-brands-svg-icons';
import SocialIcon from '@components/Footer/SocialIcon';

export default function SocialNavigation({ className }: { className: string }) {
  return (
    <Col className={className} md={6} lg={12}>
      <h3>Volg ons via social!</h3>
      <ul className="pt-2">
        <li className="pr-2">
          <SocialIcon icon={faLinkedin} link={'https://nl.linkedin.com/company/carel-lurvink-b.v.'} />
        </li>
        <li className="pr-2">
          <SocialIcon icon={faFacebook} link={'https://nl-nl.facebook.com/carellurvink/'} />
        </li>
        <li className="pr-2">
          <SocialIcon icon={faInstagram} link={'https://www.instagram.com/carellurvink/?hl=nl'} />
        </li>
        <li className="pr-2">
          <SocialIcon icon={faYoutube} link={'https://www.youtube.com/channel/UCGcL3a-DPqrYGpPWcT9ZEGg'} />
        </li>
        <li>
          <SocialIcon icon={faQuoteRight} link={'/blog'} />
        </li>
      </ul>
    </Col>
  );
}
